import { Button, IconButton, Stack, Tooltip, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';

import type { IMvpQuickAction } from './MvpSubNav';

interface IMvpQuickActionsProps {
    actions: IMvpQuickAction[];
}

function MvpQuickActions({ actions }: IMvpQuickActionsProps) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    if (isMobile) {
        return null;
    }

    return (
        <Stack direction="row" spacing={2}>
            {actions.map((action) => (
                <Button
                    key={action.id}
                    variant="text"
                    size="small"
                    startIcon={action.icon}
                    onClick={action.onClick}
                    sx={{
                        textTransform: 'none',
                        color: 'text.secondary',
                        px: 1,
                        '&:hover': {
                            bgcolor: 'action.hover',
                            color: 'text.primary',
                        },
                    }}
                >
                    {action.label}
                </Button>
            ))}
        </Stack>
    );
}

export default MvpQuickActions;
